import type { HistoricoItem } from '../types';

interface CartaoHistoricoProps {
  itens: HistoricoItem[];
}

export default function CartaoHistorico({ itens }: CartaoHistoricoProps) {
  if (itens.length === 0) {
    return (
      <div className="rounded-lg border border-secondary-200 bg-white p-8 text-center">
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-secondary-100 text-secondary-400">
          <i className="ri-footprint-line text-3xl" />
        </span>
        <p className="mt-4 text-[15px] font-medium text-foreground-950">
          Sua caminhada começa aqui.
        </p>
        <p className="mt-1 text-sm text-secondary-500">
          Assim que participar do primeiro evento, ele aparece nesta lista.
        </p>
      </div>
    );
  }

  return (
    <div className="rounded-lg border border-secondary-200 bg-white p-6">
      <ol className="space-y-0">
        {itens.map((item, indice) => {
          const detalhe = item.equipe ? `${item.participacao} · ${item.equipe}` : item.participacao;
          const ehUltimo = indice === itens.length - 1;

          return (
            <li key={`${item.ano}-${item.evento}-${indice}`} className="flex gap-3">
              <div className="flex flex-col items-center">
                <span className="mt-1.5 flex h-3 w-3 shrink-0 rounded-full bg-primary-500" />
                {!ehUltimo && <span className="w-px flex-1 bg-secondary-200" />}
              </div>

              <div className={`min-w-0 flex-1 ${ehUltimo ? '' : 'pb-6'}`}>
                <p className="text-sm text-secondary-500">{item.ano}</p>
                <p className="mt-0.5 text-[15px] font-medium text-foreground-950">{item.evento}</p>
                <p className="mt-0.5 text-sm text-secondary-600">{detalhe}</p>
                {!item.ja_aconteceu && (
                  <span className="mt-2 inline-block rounded-full bg-primary-100 px-3 py-0.5 text-xs font-medium text-primary-700">
                    Inscrito · vai acontecer
                  </span>
                )}
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
}